import { Component, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PageStatus } from '../util/page-status';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorMatcher } from '../login/error-matcher';
import { ConfirmValidParentMatcher, errorMessages, CustomValidators } from 'app/util/custom-validation';
import { AuthenticationService } from 'app/services/data/authentication.service';
import { ERROR } from '@co-assist/library';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
    pageStatus = inject(PageStatus);
    errorMatcher = inject(ErrorMatcher);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private authenticationService = inject(AuthenticationService);
    private fb = inject(UntypedFormBuilder);

    isLoading: WritableSignal<boolean> = signal(false);
    firstTime: boolean = true;
    resetPassword: boolean = true;
    oldLink: boolean = false;
    askDifferentPassword: boolean = false;
    authetic: boolean = false;
    conform: string = '';
    form: UntypedFormGroup;
    second: number = 4;
    hasBeenReset: boolean = false;
    hide: boolean = true;
    loginID: string;
    verificationToken;
    timeMs: number;
    matcher = new ConfirmValidParentMatcher();
    errors: any = errorMessages; // Error List

    constructor() {
        this.errorMatcher.clear();
    }

    get wrongLink(): boolean {
        return !this.loginID && !this.verificationToken;
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.loginID = params['loginID'];
            this.verificationToken = params['verificationToken'];
            this.timeMs = params['timeMS'];
            this.checkTokenDate();
        });
        this.form = this.fb.group({
            loginID: [{ value: this.loginID, disabled: true }, [Validators.required]],
            passwordGroup: this.fb.group({
                password: [null, [
                    Validators.required,
                    Validators.pattern(/^[0-9]{6}$/),
                    CustomValidators.forbiddenEasyPin // Référence à votre fonction
                ]],
                confirmPassword: [null, [Validators.required]]
            }, { validators: [CustomValidators.childrenEqual] }) // Validateur au niveau du groupe
        });
    }
    submit() {
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.isLoading.set(true);
            this.authenticationService.resetPassword({
                loginID: this.loginID,
                lostToken: this.verificationToken,
                newPassword: this.form.get('passwordGroup').get('password').value
            })
                .subscribe({
                    next: () => {
                        this.isLoading.set(false);
                        this.hasBeenReset = true;
                        this.redirect();
                    },
                    error: err => {
                        this.isLoading.set(false);
                        const errorMessage: string = this.errorMatcher.setError(err);
                        switch (errorMessage) {
                            case ERROR.ERROR_MESSAGES.WRONG_UPDATE_LINK:
                                this.resetPassword = false;
                                break;
                            case ERROR.ERROR_MESSAGES.LINK_EXPIRED:
                                this.oldLink = true;
                                this.resetPassword = false;
                                break;
                            case ERROR.ERROR_MESSAGES.NEW_PASSWORD_NEEDED:
                                this.askDifferentPassword = true;
                                this.resetPassword = true;
                        }
                    }
                });
        }
    }

    getPasswordError() {
        const control = this.form.get('passwordGroup.password');
        if (control.hasError('required')) return this.errors.passwordRequired;
        if (control.hasError('easyPin')) return this.errors.pinTooSimple;
        if (control.hasError('pattern')) return this.errors.passwordPattern;
        return '';
    }

    private redirect(): void {
        let id = setInterval(() => {
            if (this.second === 0) {
                clearInterval(id);
                this.router.navigate(['login']);
            } else {
                this.second--;
            }
        }, 1000);
    }

    private checkTokenDate() {
        this.isLoading.set(true);
        const aDayInMs = 86400000;
        const isTooOld = (Date.now() - this.timeMs) < 0 || (Date.now() - this.timeMs) > aDayInMs;
        if (isTooOld) {
            this.oldLink = true;
            this.resetPassword = false;
        }
        this.isLoading.set(false);
    }
}
